<template>
  <v-container>
    <form color="transparent" width="100%">
      <div>
        <v-row>
          <v-col>
            <h2>Edit Location</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="location.name"
              label="Name"
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="location.locationContact"
              label="Contact"
              filled
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="location.phoneNumber"
              label="Phone Number"
              filled
              maxLength="10"
            ></v-text-field>
          </v-col>
        </v-row>
        <hr class="horizontal black my-1 mt-3 mb-5" />
        <v-row>
          <v-col>
            <h5 class="font-weight-light">Address Details</h5>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="location.address1"
              label="Address 1"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="location.address2"
              label="Address 2"
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              filled
              v-model="location.city"
              label="City"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              filled
              v-model="location.state"
              label="State"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              filled
              v-model="location.zip"
              label="Zip"
              maxLength="7"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn outlined class="" width="100%" @click="updateLocation">Update Location</v-btn>
        <v-row>
          <v-col> </v-col>
        </v-row>
      </div>
    </form>
  </v-container>
</template>
<script>
export default {
  name: "EditLocation",
  props: {
    hideForm: Function,
  },
  data() {
    return {
      location: {
        key: 1,
        name: "Facility 1",
        address1: "123 Main St",
        address2: "",
        city: "Dallas",
        state: "TX",
        zip: "75001",
        phoneNumber: "1234567890",
        locationContact: "John Doe",
      },
    };
  },
  methods: {
    updateLocation() {
      this.$store.dispatch("updateLocation", this.location);
      this.hideForm();
    },
  },
  async created() {
    this.location = await this.$store.state.location;
  },
};
</script>
